<template>
  <div class="content-wrap">
    <!-- 영업기회ID -->
    <div class="row gx-3">
      <div class="col-md-3 col-sm-12">
        <div class="border h-100">
          <!-- <div class="py-3 px-3 dotline-b">
              <input type="text" class="form-control form-control-sm" id="" value="부서명" placeholder="부서명" v-model="state.searchDepth" @keyup.enter="onSearch()">
            </div> -->

          <!--TREE 공통컴포넌트-->
          <Tree ref="treeRef" :menuList="state.treeData" :parent-id="'up_dept_cd'" :id="'dept_cd'" :id-nm="'dept_nm'"
            :root-val="''" @return="r => getDeptData(r)" @addRow="r => addRow(r)" @updateRow="r => updateRow(r)"
            @deleteRow="r => deleteRow(r)"/>
        </div>
      </div>
      <div class="col-md-9 col-sm-12">
        <div class="border p-3 h-100">

            <div class="sch-sm-group">
              <div class="sch-sm-item">
                <div class="row">
                  <ElLabel classNm="col-auto col-form-label" name="사번">
                    <template #end="{id}">
                      <div class="col-sm-3">
                        <ElInput :id="id" v-model="state.searchParams.employee_id"  @inputKeyupEnter="searchEvent"/>
                      </div>
                    </template>
                  </ElLabel>
                  
                  <ElLabel classNm="col-auto col-form-label" name="아이디">
                    <template #end="{id}">
                      <div class="col-sm-3">
                        <ElInput :id="id" v-model="state.searchParams.user_id" @inputKeyupEnter="searchEvent"/>
                      </div>
                    </template>
                  </ElLabel>

                  <ElLabel classNm="col-auto col-form-label" name="이름">
                    <template #end="{id}">
                      <div class="col-sm-3">
                        <ElInput :id="id" v-model="state.searchParams.user_nm" @inputKeyupEnter="searchEvent"/>
                      </div>
                    </template>
                  </ElLabel>
                </div>
              </div>
                <ElButton class="sch-sm-btn" @buttonClick="searchEvent()" >
                  <span class="ic-sch"></span>
                </ElButton>
              </div>
              <div class="d-flex justify-content-between mt-3">
                <div></div>
                <div class="table-btn-group">
                  <ElButton type="excelDownload" @buttonClick="excelDownload()">엑셀다운</ElButton>
                </div>
              </div>
              <div class="table-responsive table-line">
                <DataTable  
                      :value="state.gridRowData"   
                      selectionMode="single"
                      paginator 
                      :rows="20" 
                      :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
                      @rowSelect="onRowSelect"
                      scrollable
                      scrollHeight="400px"
                      >
                      <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>
                      <Column
                        v-for="(users,index) of state.gridColumn" 
                        :key="index" 
                        :field="users.field" 
                        :header="users.headerName" 
                        sortable 
                        :style="users.style">
                        <template #body="{ data, field }">
                            <span v-if="users.field == 'user_id'" v-bind:title="data.user_id">{{ data.user_id }}</span>
                            <span v-else>{{ data[field] }}</span>
                        </template>
                      </Column>
                    </DataTable>
              </div>
            <div class="text-end py-3">
              <ElButton v-if="canUpdate" type="primary" @buttonClick="$router.push('/cf/MCF_US_002')">신규등록</ElButton>
            </div>
        </div>
      </div>
    </div>
    </div>
  <ExcelManage v-show="false" ref="excelManage" :data-format="false"/>
</template>

<script setup>
import { reactive, ref, onBeforeMount, computed } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tree from '@/components/common/SettingTree.vue';
import ExcelManage from '@/components/common/MCO_EX_001.vue';
import vueRouterCmn from '@/js/vueRouterCmn';

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { deptList } from '@/api/dept';
import { userSearch } from '@/api/userInfo';
import common from '@/js/common';
const excelManage = ref();
const treeRef = ref();

const canUpdate = computed(()=>{
  return common.checkAccessAuth('M007M002M001')
})
onBeforeMount(async () => {
  await getDepthList()
})

const state = reactive({
  treeData: [],
  dept: {
    dept_cd: '',
    dept_nm: '',
    up_dept_cd: '',
    note: '',
    add_dt: '',
    std_dt: '',
    enable_yn: ''
  },
  excelList: [],
  //컬럼 셋팅
  gridColumn: [
    //width 로 각 셀 크기 조절 가능
    { headerName: '사번', field: "employee_id", style: { minWidth: '100px' } },
    { headerName: '아이디', field: "user_id", style: { minWidth: '150px' } },
    { headerName: '이름', field: "user_nm", style: { minWidth: '100px' } },
    { headerName: '이메일', field: "email", style: { minWidth: '275px' } },
    { headerName: '휴대폰', field: "mobile", style: { minWidth: '150px' } },
  ],
  //백에서 받아와서 보여줄 list 데이터
  gridRowData: [],
  selectedRow: [],

  searchParams: {
    user_seq: '',
    employee_id: '',
    user_id: '',
    user_nm: '',
    page_count: 1,
    unit_count: 100000,
  },
});

const getSummaryData = (item) => {

let summaryData = item.length > 10 ? item.slice(0, 10) + " ..." : item;

return summaryData
}


//부서 리스트 조회
const getDepthList = async () => {
  try {
    setIsLoading(true)
    const res = await deptList()
    if (state.dept.dept_cd) {
      res.rtn.map((item) => {
        if (item.dept_cd == state.dept.dept_cd) {
          item.clickYn = 'Y'
        }
      })
    }
    state.treeData = [...res.rtn]
  } catch (err) {
    console.error(err)
    alert('부서데이터를 불러오는데 실패했습니다.')
  } finally {
    setIsLoading(false)
  }
}

const getDeptData = (dept) => {

  state.dept.dept_cd = dept.dept_cd ? dept.dept_cd : ''
  state.dept.dept_nm = dept.dept_nm ? dept.dept_nm : ''


  getUserList()

}

const searchEvent = () => {
  getUserList();
}

const getUserList = async () => {
  let params = {
    employee_id: state.searchParams.employee_id,
    user_id: state.searchParams.user_id,
    user_nm: state.searchParams.user_nm,
    dept_cd: state.dept.dept_cd
  }

  try {
    setIsLoading(true)
    const res = await userSearch(params)
    state.gridRowData = res.rtn;
  } catch (err) {
    console.error('/userInfo/userSearch ERROR!! => ' + err)
    alert('사용자조회 정보를 불러오는데 실패했습니다.')
  } finally {
    setIsLoading(false)
  }
}

const onRowSelect = (users) => {
  if (users.type == 'row') {
    if(canUpdate.value){
      vueRouterCmn.routerPush('MCF_US_003', { user_seq: users.data.user_seq })
    }else{
      vueRouterCmn.routerPush('MCF_US_004', { user_seq: users.data.user_seq })
    }
  }
}

const excelDownload = () => {
  let fileNm = '사용자조회'
  let header = state.gridColumn
  let dataList = state.gridRowData

  excelManage.value.excelDownload(fileNm, header, dataList)
}

</script>